import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Header from "../../User/Header";

import { useAxios } from "../../shared/hooks/useAxios";
import { useNotification } from "../../shared/hooks/useNotification";

import { logo_simples } from "../../assets/logos";

const SelecionarCanais = () => {
    const [canais, setCanais] = useState([]);

    const { loading, notAuthorized, fetchData } = useAxios();
    const notify = useNotification();

    const carregarCanais = async () => {
        const { data, error } = await fetchData({
            method: "get",
            url: "/api/pagina-entidade/carregar-canais"
        });

        if (!error) {
            setCanais(data);
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    useEffect(() => {
        carregarCanais();
    }, []);

    return (
        <div className="container-selecionar-canais">
            <Header titulo="Selecione o canal" />
            <div className="bloco-selecionar-canais">
                <div className="container-canais">
                    {canais.map(canal => {
                        const isExterno = !!canal.dominio;
                        const href = canal.info?.url
                            ? canal.dominio
                                ? `https://${canal.dominio}/${canal.info?.url}`
                                : `/${canal.info?.url}`
                            : `https://${canal.info?.url}`;

                        if (isExterno)
                            return (
                                <a className="btn-canal" href={href} key={canal.id}>
                                    <span className="icon">
                                        <img src={canal.info?.icon ? canal.info.icon : logo_simples} alt={canal.nome} />
                                    </span>
                                    <span className="nome">{canal.nome}</span>
                                </a>
                            );

                        return (
                            <Link className="btn-canal" to={href} key={canal.id}>
                                <span className="icon">
                                    <img src={canal.info?.icon ? canal.info.icon : logo_simples} alt={canal.nome} />
                                </span>
                                <span className="nome">{canal.nome}</span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SelecionarCanais;
